// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.company-form-modal {
  background: white;
  border-radius: 8px;
  width: 100%;
  max-width: 900px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e0e0e0;
}

.modal-header h2 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #333;
}

.modal-close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.modal-close-btn:hover {
  background-color: #f0f0f0;
  color: #333;
}

.company-form {
  flex: 1 1;
  overflow-y: auto;
  padding: 24px;
}

.form-section {
  margin-bottom: 32px;
}

.form-section:last-of-type {
  margin-bottom: 24px;
}

.form-section h3 {
  margin: 0 0 16px 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  padding-bottom: 8px;
  border-bottom: 2px solid #e0e0e0;
}

.form-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 16px;
  margin-bottom: 16px;
}

.form-field {
  display: flex;
  flex-direction: column;
}

.form-field label {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 6px;
}

.form-field input,
.form-field select,
.form-field textarea {
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  transition: border-color 0.2s;
}

.form-field input:focus,
.form-field select:focus,
.form-field textarea:focus {
  outline: none;
  border-color: #4CAF50;
}

.form-field input.error,
.form-field select.error {
  border-color: #f44336;
}

.form-field .error-message {
  color: #f44336;
  font-size: 12px;
  margin-top: 4px;
}

.form-textarea {
  resize: vertical;
  min-height: 80px;
}

.payday-inputs {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.payday-inputs .payday-number {
  width: 80px;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  cursor: pointer;
}

.checkbox-label input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px 24px;
  border-top: 1px solid #e0e0e0;
  background-color: #f9f9f9;
}

.btn {
  padding: 10px 24px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-primary {
  background-color: #4CAF50;
  color: white;
}

.btn-primary:hover:not(:disabled) {
  background-color: #45a049;
}

.btn-secondary {
  background-color: #f0f0f0;
  color: #333;
}

.btn-secondary:hover:not(:disabled) {
  background-color: #e0e0e0;
}

/* 스크롤바 스타일링 */
.company-form::-webkit-scrollbar {
  width: 8px;
}

.company-form::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.company-form::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.company-form::-webkit-scrollbar-thumb:hover {
  background: #555;
}



/* ---- 기업 등록·수정 모달 (cfm-). 위의 규칙들은 다른 모달이 같이 쓰므로 그대로 둔다. ---- */
.cfm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.cfm-modal {
  width: min(860px, 94vw);
  max-height: 92vh;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);
  text-align: left;
}
.cfm-header,
.cfm-footer { display: flex; align-items: center; gap: 12px; padding: 12px 20px; }
.cfm-header { border-bottom: 1px solid #e1e5e9; }
.cfm-header h3 { margin: 0; font-size: 17px; }
.cfm-header .cfm-muted { flex: 1 1; }
.cfm-footer { justify-content: flex-end; border-top: 1px solid #e1e5e9; }
.cfm-footer-note { flex: 1 1; color: #c92a2a; font-size: 13px; font-weight: 600; }
.cfm-muted { color: #868e96; font-size: 12.5px; font-weight: 400; }
.cfm-required { color: #e03131; font-weight: 700; }
.cfm-close {
  width: 28px;
  height: 28px;
  padding: 0;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  background: #f8f9fa;
  color: #495057;
  cursor: pointer;
}
.cfm-close:hover { background: #e9ecef; }

/* 등록을 막는 칸 목록 */
.cfm-problems { margin: 12px 20px 0; padding: 10px 14px; border: 1px solid #ffa8a8; border-radius: 6px; background: #fff5f5; }
.cfm-problems-title { margin-bottom: 4px; color: #c92a2a; font-size: 13.5px; font-weight: 700; }
.cfm-problems ul { margin: 0; padding-left: 18px; color: #c92a2a; }
.cfm-problems button {
  padding: 2px 0;
  border: none;
  background: none;
  color: #a51111;
  font: inherit;
  font-size: 13px;
  text-align: left;
  cursor: pointer;
}
.cfm-problems button:hover:not(:disabled) { text-decoration: underline; }
.cfm-problems button:disabled { cursor: default; }

.cfm-body { overflow-y: auto; padding: 4px 20px 16px; }
.cfm-body section { padding: 14px 0; border-bottom: 1px solid #f0f0f0; }
.cfm-body section:last-child { border-bottom: none; }
.cfm-body h4 { margin: 0 0 10px; font-size: 14px; }

.cfm-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 12px 16px; }
@media (max-width: 720px) { .cfm-grid { grid-template-columns: 1fr; } }
.cfm-field { display: flex; flex-direction: column; gap: 4px; min-width: 0; }
.cfm-field.wide { grid-column: 1 / -1; }
.cfm-field > label { color: #495057; font-size: 12.5px; font-weight: 600; }
.cfm-modal input:not([type='checkbox']),
.cfm-modal select,
.cfm-modal textarea {
  width: 100%;
  padding: 0 10px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  background: #fff;
  color: #212529;
  font: inherit;
  font-size: 14px;
  box-sizing: border-box;
}
.cfm-modal input:not([type='checkbox']),
.cfm-modal select { height: 34px; }
.cfm-modal textarea { padding: 8px 10px; resize: vertical; }
.cfm-modal input:focus,
.cfm-modal select:focus,
.cfm-modal textarea:focus { border-color: #217346; outline: 2px solid #cfe6d8; }
.cfm-modal input:disabled { background: #e9ecef; }
.cfm-hint { color: #868e96; font-size: 12px; }

/* 문제가 있는 칸 */
.cfm-modal .has-error input:not([type='checkbox']),
.cfm-modal .has-error select { border-color: #e03131; background: #fff5f5; }
.cfm-modal .has-error > label { color: #c92a2a; }
.cfm-error-text { color: #c92a2a; font-size: 12px; font-weight: 600; }

.cfm-payday { display: flex; align-items: center; gap: 10px; }
.cfm-payday input[type='number'] { width: 80px; }
.cfm-check { display: inline-flex; align-items: center; gap: 6px; color: #343a40; font-size: 14px; font-weight: 400; cursor: pointer; }

.cfm-table { width: 100%; border-collapse: collapse; }
.cfm-table th { padding: 4px 8px; color: #495057; font-size: 12.5px; text-align: left; }
.cfm-table tbody th { font-weight: 600; white-space: nowrap; }
.cfm-table td { padding: 3px 4px; vertical-align: top; }
`, "",{"version":3,"sources":["webpack://./src/components/CompanyFormModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;;;EAGE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,cAAc;AACd;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;;;AAIA,gEAAgE;AAChE;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,gBAAgB;AAClB;AACA;cACc,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,kBAAkB,EAAE;AACjF,cAAc,gCAAgC,EAAE;AAChD,iBAAiB,SAAS,EAAE,eAAe,EAAE;AAC7C,yBAAyB,SAAO,EAAE;AAClC,cAAc,yBAAyB,EAAE,6BAA6B,EAAE;AACxE,mBAAmB,SAAO,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC/E,aAAa,cAAc,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AAClE,gBAAgB,cAAc,EAAE,gBAAgB,EAAE;AAClD;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA,mBAAmB,mBAAmB,EAAE;;AAExC,gBAAgB;AAChB,gBAAgB,mBAAmB,EAAE,kBAAkB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;AAC7H,sBAAsB,kBAAkB,EAAE,cAAc,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AAC/F,mBAAmB,SAAS,EAAE,kBAAkB,EAAE,cAAc,EAAE;AAClE;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA,4CAA4C,0BAA0B,EAAE;AACxE,gCAAgC,eAAe,EAAE;;AAEjD,YAAY,gBAAgB,EAAE,sBAAsB,EAAE;AACtD,oBAAoB,eAAe,EAAE,gCAAgC,EAAE;AACvE,+BAA+B,mBAAmB,EAAE;AACpD,eAAe,gBAAgB,EAAE,eAAe,EAAE;;AAElD,YAAY,aAAa,EAAE,gDAAgD,EAAE,cAAc,EAAE;AAC7F,4BAA4B,YAAY,0BAA0B,EAAE,EAAE;AACtE,aAAa,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,YAAY,EAAE;AAC5E,kBAAkB,mBAAmB,EAAE;AACvC,qBAAqB,cAAc,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AAC1E;;;EAGE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,eAAe;EACf,sBAAsB;AACxB;AACA;oBACoB,YAAY,EAAE;AAClC,sBAAsB,iBAAiB,EAAE,gBAAgB,EAAE;AAC3D;;4BAE4B,qBAAqB,EAAE,0BAA0B,EAAE;AAC/E,4BAA4B,mBAAmB,EAAE;AACjD,YAAY,cAAc,EAAE,eAAe,EAAE;;AAE7C,aAAa;AACb;+BAC+B,qBAAqB,EAAE,mBAAmB,EAAE;AAC3E,gCAAgC,cAAc,EAAE;AAChD,kBAAkB,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;;AAErE,cAAc,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AAC7D,mCAAmC,WAAW,EAAE;AAChD,aAAa,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE;;AAEtI,aAAa,WAAW,EAAE,yBAAyB,EAAE;AACrD,gBAAgB,gBAAgB,EAAE,cAAc,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AACvF,sBAAsB,gBAAgB,EAAE,mBAAmB,EAAE;AAC7D,gBAAgB,gBAAgB,EAAE,mBAAmB,EAAE","sourcesContent":[".modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n  padding: 20px;\r\n}\r\n\r\n.company-form-modal {\r\n  background: white;\r\n  border-radius: 8px;\r\n  width: 100%;\r\n  max-width: 900px;\r\n  max-height: 90vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.modal-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 20px 24px;\r\n  border-bottom: 1px solid #e0e0e0;\r\n}\r\n\r\n.modal-header h2 {\r\n  margin: 0;\r\n  font-size: 24px;\r\n  font-weight: 600;\r\n  color: #333;\r\n}\r\n\r\n.modal-close-btn {\r\n  background: none;\r\n  border: none;\r\n  font-size: 24px;\r\n  cursor: pointer;\r\n  color: #666;\r\n  padding: 0;\r\n  width: 32px;\r\n  height: 32px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 4px;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.modal-close-btn:hover {\r\n  background-color: #f0f0f0;\r\n  color: #333;\r\n}\r\n\r\n.company-form {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 24px;\r\n}\r\n\r\n.form-section {\r\n  margin-bottom: 32px;\r\n}\r\n\r\n.form-section:last-of-type {\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.form-section h3 {\r\n  margin: 0 0 16px 0;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  color: #333;\r\n  padding-bottom: 8px;\r\n  border-bottom: 2px solid #e0e0e0;\r\n}\r\n\r\n.form-row {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\r\n  gap: 16px;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.form-field {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.form-field label {\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  color: #333;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.form-field input,\r\n.form-field select,\r\n.form-field textarea {\r\n  padding: 10px 12px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n  font-size: 14px;\r\n  transition: border-color 0.2s;\r\n}\r\n\r\n.form-field input:focus,\r\n.form-field select:focus,\r\n.form-field textarea:focus {\r\n  outline: none;\r\n  border-color: #4CAF50;\r\n}\r\n\r\n.form-field input.error,\r\n.form-field select.error {\r\n  border-color: #f44336;\r\n}\r\n\r\n.form-field .error-message {\r\n  color: #f44336;\r\n  font-size: 12px;\r\n  margin-top: 4px;\r\n}\r\n\r\n.form-textarea {\r\n  resize: vertical;\r\n  min-height: 80px;\r\n}\r\n\r\n.payday-inputs {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.payday-inputs .payday-number {\r\n  width: 80px;\r\n}\r\n\r\n.checkbox-label {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n}\r\n\r\n.checkbox-label input[type=\"checkbox\"] {\r\n  width: 18px;\r\n  height: 18px;\r\n  cursor: pointer;\r\n}\r\n\r\n.modal-footer {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 12px;\r\n  padding: 20px 24px;\r\n  border-top: 1px solid #e0e0e0;\r\n  background-color: #f9f9f9;\r\n}\r\n\r\n.btn {\r\n  padding: 10px 24px;\r\n  border: none;\r\n  border-radius: 4px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.btn:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.btn-primary {\r\n  background-color: #4CAF50;\r\n  color: white;\r\n}\r\n\r\n.btn-primary:hover:not(:disabled) {\r\n  background-color: #45a049;\r\n}\r\n\r\n.btn-secondary {\r\n  background-color: #f0f0f0;\r\n  color: #333;\r\n}\r\n\r\n.btn-secondary:hover:not(:disabled) {\r\n  background-color: #e0e0e0;\r\n}\r\n\r\n/* 스크롤바 스타일링 */\r\n.company-form::-webkit-scrollbar {\r\n  width: 8px;\r\n}\r\n\r\n.company-form::-webkit-scrollbar-track {\r\n  background: #f1f1f1;\r\n}\r\n\r\n.company-form::-webkit-scrollbar-thumb {\r\n  background: #888;\r\n  border-radius: 4px;\r\n}\r\n\r\n.company-form::-webkit-scrollbar-thumb:hover {\r\n  background: #555;\r\n}\r\n\r\n\r\n\r\n/* ---- 기업 등록·수정 모달 (cfm-). 위의 규칙들은 다른 모달이 같이 쓰므로 그대로 둔다. ---- */\r\n.cfm-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(0, 0, 0, 0.45);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n}\r\n.cfm-modal {\r\n  width: min(860px, 94vw);\r\n  max-height: 92vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: #fff;\r\n  border-radius: 8px;\r\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);\r\n  text-align: left;\r\n}\r\n.cfm-header,\r\n.cfm-footer { display: flex; align-items: center; gap: 12px; padding: 12px 20px; }\r\n.cfm-header { border-bottom: 1px solid #e1e5e9; }\r\n.cfm-header h3 { margin: 0; font-size: 17px; }\r\n.cfm-header .cfm-muted { flex: 1; }\r\n.cfm-footer { justify-content: flex-end; border-top: 1px solid #e1e5e9; }\r\n.cfm-footer-note { flex: 1; color: #c92a2a; font-size: 13px; font-weight: 600; }\r\n.cfm-muted { color: #868e96; font-size: 12.5px; font-weight: 400; }\r\n.cfm-required { color: #e03131; font-weight: 700; }\r\n.cfm-close {\r\n  width: 28px;\r\n  height: 28px;\r\n  padding: 0;\r\n  border: 1px solid #dee2e6;\r\n  border-radius: 4px;\r\n  background: #f8f9fa;\r\n  color: #495057;\r\n  cursor: pointer;\r\n}\r\n.cfm-close:hover { background: #e9ecef; }\r\n\r\n/* 등록을 막는 칸 목록 */\r\n.cfm-problems { margin: 12px 20px 0; padding: 10px 14px; border: 1px solid #ffa8a8; border-radius: 6px; background: #fff5f5; }\r\n.cfm-problems-title { margin-bottom: 4px; color: #c92a2a; font-size: 13.5px; font-weight: 700; }\r\n.cfm-problems ul { margin: 0; padding-left: 18px; color: #c92a2a; }\r\n.cfm-problems button {\r\n  padding: 2px 0;\r\n  border: none;\r\n  background: none;\r\n  color: #a51111;\r\n  font: inherit;\r\n  font-size: 13px;\r\n  text-align: left;\r\n  cursor: pointer;\r\n}\r\n.cfm-problems button:hover:not(:disabled) { text-decoration: underline; }\r\n.cfm-problems button:disabled { cursor: default; }\r\n\r\n.cfm-body { overflow-y: auto; padding: 4px 20px 16px; }\r\n.cfm-body section { padding: 14px 0; border-bottom: 1px solid #f0f0f0; }\r\n.cfm-body section:last-child { border-bottom: none; }\r\n.cfm-body h4 { margin: 0 0 10px; font-size: 14px; }\r\n\r\n.cfm-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 12px 16px; }\r\n@media (max-width: 720px) { .cfm-grid { grid-template-columns: 1fr; } }\r\n.cfm-field { display: flex; flex-direction: column; gap: 4px; min-width: 0; }\r\n.cfm-field.wide { grid-column: 1 / -1; }\r\n.cfm-field > label { color: #495057; font-size: 12.5px; font-weight: 600; }\r\n.cfm-modal input:not([type='checkbox']),\r\n.cfm-modal select,\r\n.cfm-modal textarea {\r\n  width: 100%;\r\n  padding: 0 10px;\r\n  border: 1px solid #ced4da;\r\n  border-radius: 4px;\r\n  background: #fff;\r\n  color: #212529;\r\n  font: inherit;\r\n  font-size: 14px;\r\n  box-sizing: border-box;\r\n}\r\n.cfm-modal input:not([type='checkbox']),\r\n.cfm-modal select { height: 34px; }\r\n.cfm-modal textarea { padding: 8px 10px; resize: vertical; }\r\n.cfm-modal input:focus,\r\n.cfm-modal select:focus,\r\n.cfm-modal textarea:focus { border-color: #217346; outline: 2px solid #cfe6d8; }\r\n.cfm-modal input:disabled { background: #e9ecef; }\r\n.cfm-hint { color: #868e96; font-size: 12px; }\r\n\r\n/* 문제가 있는 칸 */\r\n.cfm-modal .has-error input:not([type='checkbox']),\r\n.cfm-modal .has-error select { border-color: #e03131; background: #fff5f5; }\r\n.cfm-modal .has-error > label { color: #c92a2a; }\r\n.cfm-error-text { color: #c92a2a; font-size: 12px; font-weight: 600; }\r\n\r\n.cfm-payday { display: flex; align-items: center; gap: 10px; }\r\n.cfm-payday input[type='number'] { width: 80px; }\r\n.cfm-check { display: inline-flex; align-items: center; gap: 6px; color: #343a40; font-size: 14px; font-weight: 400; cursor: pointer; }\r\n\r\n.cfm-table { width: 100%; border-collapse: collapse; }\r\n.cfm-table th { padding: 4px 8px; color: #495057; font-size: 12.5px; text-align: left; }\r\n.cfm-table tbody th { font-weight: 600; white-space: nowrap; }\r\n.cfm-table td { padding: 3px 4px; vertical-align: top; }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
